import * as React from 'react';
import { Route, Redirect } from "react-router";
import Welcome from './components/Welcome';
import Layout from './components/Layout';
import Home from './components/Home';
import UploadData from './components/UploadData';
import Mer from './components/Mer';
import Site from './components/Site';
import Uploads from './components/Uploads';
import Refill from './components/Refill';
import MissedAppointment from './components/MissedAppointment';
import Patient from './components/Patient';
import DataManagement from './components/DataManagement';
import User from './components/Users';
import Pvls from './components/pvls';
import Dashboard from './components/Dashboard';
import Tracking from './components/Tracking';
import OnboardingAudit from './components/OnboardingAudit';
import EDQA from './components/Edqa';
import Manifests from './components/LimsManifest';
import Reason from './components/Reason';
import Providers from './components/Providers';
import Dispatchers from './components/Dispatchers';
import CounsellingRequests from './components/CounsellingRequests';
import ArtSchedule from './components/ArtSchedule';
import VlSchedule from './components/VlSchedule';
import DataArchive from './components/DataArchive';
import AppMessaging from './components/AppMessaging';
import CitDashbboardQ1FY27 from './components/CitDashboardQ1FY27';
import CitDashbboardQ4FY26 from './components/CitDashboardQ4FY26';
import CitDashbboardQ3FY26 from './components/CitDashboardQ3FY26';
import CitDashbboardQ2FY26 from './components/CitDashboardQ2FY26';
import CitDashbboardQ1FY26 from './components/CitDashboardQ1FY26';
import CitDashbboardQ4FY25 from './components/CitDashboardQ4FY25';
import CitDashbboardQ3FY25 from './components/CitDashboardQ3FY25';
import CitDashbboardQ2FY25 from './components/CitDashboardQ2FY25';
import CitDashbboardQ1FY25 from './components/CitDashboardQ1FY25';
import CitDashbboardQ4FY24 from './components/CitDashboardQ4FY24';
import CitDashbboardQ3FY24 from './components/CitDashboardQ3FY24';
import CitDashbboardQ2FY24 from './components/CitDashboardQ2FY24';
import CitDashbboardQ1FY24 from './components/CitDashboardQ1FY24';
import CitDashbboardQ4FY23 from './components/CitDashboardQ4FY23';

//import './IoServer';

import 'antd/dist/antd.css';
import "./styles/main.css";
import './custom.css'
import "./styles/login.css";

export default () =>
{
    return <Layout>        
        <Route exact path='/welcome' component={Welcome} />
        <Route exact path='/citDashboard-q4-fy23' component={CitDashbboardQ4FY23} />
        <Route exact path='/citDashboard-q1-fy24' component={CitDashbboardQ1FY24} />
        <Route exact path='/citDashboard-q2-fy24' component={CitDashbboardQ2FY24} />
        <Route exact path='/citDashboard-q3-fy24' component={CitDashbboardQ3FY24} />
        <Route exact path='/citDashboard-q4-fy24' component={CitDashbboardQ4FY24} />
        <Route exact path='/citDashboard-q1-fy25' component={CitDashbboardQ1FY25} />
        <Route exact path='/citDashboard-q2-fy25' component={CitDashbboardQ2FY25} />
        <Route exact path='/citDashboard-q3-fy25' component={CitDashbboardQ3FY25} />
        <Route exact path='/citDashboard-q4-fy25' component={CitDashbboardQ4FY25} />
        <Route exact path='/citDashboard-q1-fy26' component={CitDashbboardQ1FY26} />
        <Route exact path='/citDashboard-q2-fy26' component={CitDashbboardQ2FY26} />
        <Route exact path='/citDashboard-q3-fy26' component={CitDashbboardQ3FY26} />
        <Route exact path='/citDashboard-q4-fy26' component={CitDashbboardQ4FY26} />
        <Route exact path='/citDashboard-q1-fy27' component={CitDashbboardQ1FY27} />
        <Route exact path='/mer' component={Mer} />
        <Route exact path='/patient' component={Patient} />
        <Route exact path='/dataMgt' component={DataManagement} />
        <Route exact path='/' component={Home} />
        <Route exact path='/home' component={Home} />
        <Route exact path='/tracking' component={Tracking} />
        <Route exact path='/dashboard' component={Dashboard} />
        <Route exact path='/refill' component={Refill} />
        <Route exact path='/onboardingAudit' component={OnboardingAudit} />
        <Route exact path='/missedAppointments' component={MissedAppointment} />
        <Route exact path='/dueforPvls' component={Pvls} />
        <Route exact path='/uploads' component={Uploads} />
        <Route exact path='/sites' component={Site} />
        <Route exact path='/users' component={User} />
        <Route exact path='/upload' component={UploadData} />
        <Route exact path='/edqa' component={EDQA} />
        <Route exact path='/manifests' component={Manifests} />
        <Route exact path='/reasons' component={Reason} />
        <Route exact path='/providers' component={Providers} />
        <Route exact path='/dispatchers' component={Dispatchers} />
        <Route exact path='/counsellingRequests' component={CounsellingRequests} />
        <Route exact path='/artSchedules' component={ArtSchedule} />
        <Route exact path='/vlSchedules' component={VlSchedule} />
        <Route exact path='/contactDataArchive' component={DataArchive} />
        <Route exact path='/messaging' component={AppMessaging} />
    </Layout>;
}
